<app-breadcrumb [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Import'"></app-breadcrumb>
<div class="commission-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="receivablesPaymentImportForm" *ngIf="(userPermissions | async).receivables.write" >
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/xml"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="receivablesPaymentImportForm.get('fileContent').hasError('backendError')">
            {{receivablesPaymentImportForm.get('fileContent').getError('backendError')}}
          </mat-error>


        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!receivablesPaymentImportFormValid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
  </div>
</div>

